import SingleNews from "./SingleNews";

export default SingleNews